(() => {
  function runSlideAnimation(component, slide) {
    if (!slide) return;

    const transition = component.dataset.transition || 'none';

    if (transition === 'none' || transition === 'ambient') {
      return;
    }

    slide.classList.remove('syn-transition-run');

    void slide.offsetWidth;

    slide.classList.add('syn-transition-run');

    window.setTimeout(() => {
      slide.classList.remove('syn-transition-run');
    }, 1500);
  }

  function initSlideshow(component) {
    if (component.dataset.synAnimationReady === 'true') return;

    component.dataset.synAnimationReady = 'true';

    component.addEventListener('slideChanged', (event) => {
      runSlideAnimation(component, event.detail.currentElement);
    });
  }

  function initNormalAnimations(scope = document) {
    const elements = scope.querySelectorAll(
      '.syn-animate[data-syn-animation]'
    );

    elements.forEach((element) => {
      if (element.dataset.synObserved === 'true') return;

      const animation = element.dataset.synAnimation;

      if (!animation || animation === 'none') return;

      element.dataset.synObserved = 'true';
      element.classList.add('syn-before-animation');

      const observer = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            entry.target.classList.remove('syn-before-animation');

            void entry.target.offsetWidth;

            entry.target.classList.add('syn-animation-run');

            obs.unobserve(entry.target);
          });
        },
        {
          threshold: 0.12
        }
      );

      observer.observe(element);
    });
  }

  function init(scope = document) {
    scope
      .querySelectorAll('slideshow-component[data-transition]')
      .forEach(initSlideshow);

    initNormalAnimations(scope);
  }

  document.addEventListener('DOMContentLoaded', () => {
    init();
  });

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();